var resizeProportion;

resizeProportion = function(proportion) {
  var $, elem, elemHeight, elemWidth;
  $ = require('jquery');
  elem = $(proportion.element);
  if (elem.length > 0) {
    elemWidth = elem.width();
    elemHeight = (elemWidth * proportion.height) / proportion.width;
    elemHeight = Math.ceil(elemHeight);
    return elem.height(elemHeight);
  } else {
    return false;
    return console.warn("selector '" + proportion.element + "' is not found on page");
  }
};

module.exports = resizeProportion;
